import React, { useState } from "react";
import {
  ButtonContainer,
  NoDataFoundContainer,
  Container,
  Header,
  IconContainer,
  InputContainer,
  SegmentColorIndicator,
  SegmentItem,
  SegmentName,
  SegmentPreviewContainer,
  Segments,
  SegmentsContainer,
  Separator,
} from "./styles";
import TextView from "../../../TextView";
import Input from "../../../Input";
import { SegmentLibraryTabs } from "./tabs";
import { useInfiniteWheels } from "../../../../services/queries";
import { WheelCategories } from "../../../WheelGallery/WheelListing/TabComponents/WheelsTab";
import { getLoggedInUser } from "../../../../utils/helpers";
import { WheelListing } from "./WheelListing";
import { WheelListingCard } from "./WheelListingCard";
import AddIcon from "assets/images/segmentLibrary/add.svg";
import BackIcon from "assets/images/segmentLibrary/back.svg";
import { createPortal } from "react-dom";
import Editor from "../../../../pages/SegmentBuilder/Editor";
import SegmentView from "../../../SegmentView";
import { getWheelDetails } from "../../../../services/api";
import { convertSnakeToCamel } from "../../../../utils/helpers";
import { useWheelSegments } from "../../../../contexts/wheelSegments";
import { useSelector, useDispatch } from "react-redux";
import {
  getPresentState,
  getWheelAutoResizing,
  getWheelSegments,
} from "../../../../redux/selectors/segmentBuilderSelectors";
import { addNewSegmentToWheel } from "../../../../redux/reducers/segmentBuilder";
import Button from "../../../Button";
import { usePaletteColor } from "../../../../hooks/usePaletteColor";
import { CircularProgress } from "@mui/material";
import { countAllNodes } from "../SegmentsTab/SegmentsTabHelpers";
import NotFoundImage from "assets/images/segmentLibrary/notFound.svg";
import { v4 as uuidv4 } from "uuid";

export default function SegmentLibrary({ isVisible }) {
  const [searchText, setSearchText] = useState("");
  const [selectedTab, setSelectedTab] = useState("0");
  const [selectedWheelCategory, setSelectedWheelCategory] = useState(
    WheelCategories.Created
  );
  const [selectedWheel, setSelectedWheel] = useState(null);
  const [showSegments, setShowSegments] = useState(false);
  const [wheelSegments, setWheelSegments] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [showSegmentPreview, setShowSegmentPreview] = useState(false);
  const [fetchingSegments, setFetchingSegments] = useState(false);

  const dispatch = useDispatch();

  const wheel = useSelector((state) => getPresentState(state));
  const wheelData = useSelector(getWheelSegments);

  const automaticResizing = useSelector(getWheelAutoResizing);
  const { addSegments, addWheelData } = useWheelSegments();
  const { getPaletteColor } = usePaletteColor();

  const loggedInUserId = getLoggedInUser()?.id;

  // Fetch created wheels data
  const {
    data: createdWheelsData,
    fetchNextPage: fetchNextPageCreated,
    hasNextPage: hasNextPageCreated,
    isError: isErrorCreated,
    isFetching: isFetchingCreated,
    error: errorCreated,
    isFetchingNextPage: isFetchingNextPageCreated,
  } = useInfiniteWheels({
    selectedTab,
    selectedCategory: WheelCategories.Created,
    searchedText: searchText,
    userId: loggedInUserId,
  });

  // Fetch cloned wheels data
  const {
    data: clonedWheelsData,
    fetchNextPage: fetchNextPageCloned,
    hasNextPage: hasNextPageCloned,
    isError: isErrorCloned,
    isFetching: isFetchingCloned,
    error: errorCloned,
    isFetchingNextPage: isFetchingNextPageCloned,
  } = useInfiniteWheels({
    selectedTab,
    selectedCategory: WheelCategories.Cloned,
    searchedText: searchText,
    userId: loggedInUserId,
    // selectedFilters: filtersByCategory[selectedWheelCategory] || [],
  });

  // Get all wheels for the currently selected category
  const currentCategoryData =
    selectedWheelCategory === WheelCategories.Created
      ? createdWheelsData
      : clonedWheelsData;
  const allWheels =
    currentCategoryData?.pages.flatMap((page) => page.results) || [];

  // Calculate counts from respective datasets
  const allCreatedWheels =
    createdWheelsData?.pages
      .flatMap((page) => page.results)
      .filter((wheel) => wheel.version !== 1) || [];
  const allClonedWheels =
    clonedWheelsData?.pages
      .flatMap((page) => page.results)
      .filter((wheel) => wheel.is_live === false && wheel.version !== 1) || [];

  const numberOfCreatedWheels = allCreatedWheels.length;
  const numberOfClonedWheels = allClonedWheels.length;

  console.log("hama 1", allClonedWheels, allCreatedWheels);

  const filteredWheels =
    selectedWheelCategory === WheelCategories.Created
      ? allCreatedWheels
      : allClonedWheels;

  // Use the appropriate loading/error states based on selected category
  const isFetching =
    selectedWheelCategory === WheelCategories.Created
      ? isFetchingCreated
      : isFetchingCloned;
  const isError =
    selectedWheelCategory === WheelCategories.Created
      ? isErrorCreated
      : isErrorCloned;
  const error =
    selectedWheelCategory === WheelCategories.Created
      ? errorCreated
      : errorCloned;
  const isFetchingNextPage =
    selectedWheelCategory === WheelCategories.Created
      ? isFetchingNextPageCreated
      : isFetchingNextPageCloned;
  const fetchNextPage =
    selectedWheelCategory === WheelCategories.Created
      ? fetchNextPageCreated
      : fetchNextPageCloned;
  const hasNextPage =
    selectedWheelCategory === WheelCategories.Created
      ? hasNextPageCreated
      : hasNextPageCloned;

  const handleCancel = () => {
    setSearchText("");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const openWheelSegments = async (id) => {
    setShowSegments(true);
    setFetchingSegments(true);
    const wheel = filteredWheels.find((wheel) => wheel.id === id);
    setSelectedWheel(wheel);

    const res = await getWheelDetails(id);

    if (res?.data?.data) {
      const response = res.data.data;
      const { wheel_segments, ...restResponse } = response;

      const modifiedSegmentData = wheel_segments.map((s) => {
        const { nodes, ...rest } = s;

        const { activity, category, ...settingsRest } = s.settings;
        return {
          ...rest,
          category: 1, // Replace with actual category id
          settings: convertSnakeToCamel(settingsRest),
          nodes: typeof nodes === "string" ? JSON.parse(nodes) : nodes,
        };
      });

      addWheelData(restResponse);
      addSegments(modifiedSegmentData);
      setWheelSegments(modifiedSegmentData);

      setFetchingSegments(false);
    }
  };
  const previewSegment = async (id) => {
    // If the segment is already being previewed, toggle it off
    if (selectedSegment?.id === id && showSegmentPreview) {
      setShowSegmentPreview(false);
      return;
    }

    const segmentToView = wheelSegments.find((segment) => segment.id === id);
    setSelectedSegment(segmentToView);
    setShowSegmentPreview(true);
  };

  const onSegmentClose = () => {
    setShowSegmentPreview(false);
    setSelectedSegment(null);
  };
  const addSegmentToWheel = async (id) => {
    const segmentToView = wheelSegments.find((segment) => segment.id === id);

    if (!segmentToView) {
      console.error("Segment not found:", id);
      return;
    }

    // Get current wheel segments (equivalent to wheelData in addSegment)
    const currentWheelSegments = wheelData || [];

    // Create a new unique ID to avoid conflicts when adding the same segment multiple times
    let potentialId = segmentToView.id;
    while (currentWheelSegments.some((s) => s.id === potentialId)) {
      potentialId = potentialId + 1;
    }
    const newId = potentialId;

    // Check for locked segments validation (same as addSegment)
    const allLocked =
      currentWheelSegments.length > 0 &&
      currentWheelSegments.every((sb) => sb.resize_lock);
    const unlockedSegments = currentWheelSegments.filter(
      (sb) => !sb.resize_lock
    );
    unlockedSegments.sort((a, b) => b.value - a.value);

    // If everything is locked or the biggest unlocked segment is ≤ 1, prevent adding
    if (
      allLocked ||
      (unlockedSegments.length === 1 && unlockedSegments[0].value <= 1) ||
      (unlockedSegments.length > 0 && unlockedSegments[0].value <= 1)
    ) {
      console.warn(
        "Cannot add segment: insufficient space due to locked segments"
      );
      return;
    }

    // Mark all existing segments as unselected first
    let updatedWheelData = currentWheelSegments.map((segment) => ({
      ...segment,
      selected: false,
    }));

    let finalValue = segmentToView.value;

    if (automaticResizing) {
      // Gather code-block counts for *existing* segments
      let totalNodeCount = 0;
      const existingSegmentsWithCounts = updatedWheelData.map((seg) => {
        const nodeMap =
          typeof seg.nodes === "string" ? JSON.parse(seg.nodes) : seg.nodes;
        const nodeCount = countAllNodes(nodeMap, "ROOT");
        totalNodeCount += nodeCount;
        return { ...seg, node_count: nodeCount };
      });

      // For our new segment from segmentToView, count its nodes
      const newSegmentNodeMap =
        typeof segmentToView.nodes === "string"
          ? JSON.parse(segmentToView.nodes)
          : segmentToView.nodes;
      const newSegmentNodeCount = countAllNodes(newSegmentNodeMap, "ROOT") || 1;
      totalNodeCount += newSegmentNodeCount;

      // Compute the fraction => new segment's value
      const ratioForNew = newSegmentNodeCount / totalNodeCount;
      finalValue = Number((ratioForNew * 100).toFixed(2));
    } else {
      // PROPORTIONALLY REDUCE UNLOCKED SEGMENTS BEFORE INSERTING NEW ONE
      // (Same logic as addSegment when automaticResizing is false)
      const unlockedSum = unlockedSegments.reduce(
        (sum, sb) => sum + sb.value,
        0
      );

      // Distribute the new segment value so that all unlocked segments
      // share the "loss" of those points.
      const newSegmentValue = Number(
        Math.floor(unlockedSum / (unlockedSegments.length + 1)).toFixed(2)
      );

      if (newSegmentValue < 1 && unlockedSegments.length > 0) {
        console.warn(
          "Cannot add segment: would result in segments smaller than 1%"
        );
        return;
      }

      finalValue = Math.max(1, newSegmentValue);

      // Everyone loses enough total to "give" newSegmentValue to the new segment
      const valueToReduce = finalValue;
      updatedWheelData = updatedWheelData.map((sb) => {
        if (!sb.resize_lock) {
          const reductionRatio = sb.value / unlockedSum;
          const reduction = Math.floor(valueToReduce * reductionRatio);
          return {
            ...sb,
            value: Number(Math.max(1, sb.value - reduction).toFixed(2)),
          };
        }
        return sb;
      });

      console.log(
        "hama 2",
        newSegmentValue,
        unlockedSum,
        unlockedSegments,
        currentWheelSegments,
        updatedWheelData,
        finalValue
      );
    }

    // Get the segment's color (preserve from segmentToView)
    const segmentColor = segmentToView.settings?.color;

    console.log("hama 3", segmentToView);

    // Create a completely new segment with unique IDs and properties
    const newSegment = {
      id: newId,
      title:
        segmentToView?.settings?.title || segmentToView?.title || "New Segment",
      value: finalValue,
      settings: {
        color: segmentColor,
        colorInner: segmentToView.settings?.colorInner || segmentColor,
        fontSize: segmentToView.settings?.fontSize || 14,
        fontColor: segmentToView.settings?.fontColor || "#000000",
        fontFamily: segmentToView.settings?.fontFamily || "Arial",
        title:
          segmentToView?.settings?.title ||
          segmentToView?.title ||
          "New Segment",
        currentBg: segmentToView.settings?.currentBg || 0,
        segmentBgColor: segmentToView.settings?.segmentBgColor || "#FFFFFF",

        bgWallpaper: segmentToView?.settings?.bgWallpaper || "",
        icon: segmentToView?.settings?.icon || "",
        isPattern: segmentToView?.settings?.isPattern || false,
        paletteData: segmentToView?.settings?.paletteData || null,
        paletteId: segmentToView?.settings?.paletteId || null,
        patternColor: segmentToView?.settings?.patternColor || "#000000",
        patternId: segmentToView?.settings?.patternId || null,
        wallpaperOverlayColor:
          segmentToView?.settings?.wallpaperOverlayColor || "#ffffff",
        wallpaperResizing: segmentToView?.settings?.wallpaperResizing || 20,
        wallpaperTransparency:
          segmentToView?.settings?.wallpaperTransparency || 100,
      },
      nodes:
        typeof segmentToView.nodes === "string"
          ? segmentToView.nodes
          : JSON.stringify(segmentToView.nodes),
      is_modified: true,
      resize_lock: false,
      data_value: finalValue,
    };

    // Calculate data_value for all segments (including updated ones)
    let totalData = updatedWheelData.reduce((sum, s) => sum + s.data_value, 0);

    const finalUpdatedSegments = updatedWheelData.map((seg) => {
      const newDataValue = (seg.value / 100) * totalData;
      return {
        ...seg,
        data_value: Math.max(1, Math.floor(newDataValue)),
      };
    });

    const finalNewSegment = {
      ...newSegment,
      data_value: 1,
    };

    // Dispatch with both updated segments and new segment
    dispatch(
      addNewSegmentToWheel({
        updatedSegments: finalUpdatedSegments,
        newSegment: finalNewSegment,
      })
    );
  };
  const moveBack = () => {
    // Make sure the preview is closed
    if (showSegmentPreview) {
      onSegmentClose();
    }
    setShowSegments(false);
    setSelectedWheel(null);
  };

  const overlay = (
    <SegmentPreviewContainer onClick={(e) => e.stopPropagation()}>
      <TextView variant="notifName">Preview</TextView>
      <Editor enabled={false}>
        <SegmentView
          selectedArc={selectedSegment}
          onClose={onSegmentClose}
          height={"80dvh"}
          isPreview={true}
        />
      </Editor>

      <ButtonContainer>
        <Button
          style={{ width: "auto" }}
          onClick={() => addSegmentToWheel(selectedSegment?.id)}
        >
          Add Segment
        </Button>
      </ButtonContainer>
    </SegmentPreviewContainer>
  );

  return (
    <>
      <Container isVisible={isVisible}>
        <Header>
          {!showSegments ? (
            <TextView variant="title">Segment Library</TextView>
          ) : (
            <img
              src={BackIcon}
              alt="back"
              width={24}
              height={24}
              style={{ cursor: "pointer" }}
              onClick={() => moveBack()}
            />
          )}
        </Header>

        {!showSegments && !fetchingSegments && (
          <>
            <InputContainer>
              <Input
                isSearch={true}
                placeholder="Search"
                value={searchText}
                onClear={handleCancel}
                showClearIcon={searchText.length !== 0}
                onKeyUp={handleKeyPress}
                onChange={handleSearch}
                variant={"secondary"}
                containerStyle={{ marginBottom: "0px" }}
              />

              <SegmentLibraryTabs
                selectedWheelCategory={selectedWheelCategory}
                setSelectedWheelCategory={setSelectedWheelCategory}
                numberOfCreatedWheels={numberOfCreatedWheels}
                numberOfClonedWheels={numberOfClonedWheels}
              />
            </InputContainer>

            {isFetching ? (
              <NoDataFoundContainer noBorder={true}>
                <CircularProgress />
              </NoDataFoundContainer>
            ) : !filteredWheels.length ? (
              <NoDataFoundContainer>
                <img
                  src={NotFoundImage}
                  alt="No Wheels Found"
                  width={68}
                  height={56}
                />
                <TextView variant="subtitle">No results found!</TextView>
              </NoDataFoundContainer>
            ) : (
              <WheelListing
                wheels={filteredWheels}
                isFetchingNextPage={isFetchingNextPage}
                openWheel={(id) => openWheelSegments(id)}
                selectedWheelCategory={selectedWheelCategory}
              />
            )}
          </>
        )}

        {showSegments && (
          <SegmentsContainer>
            <WheelListingCard wheel={selectedWheel} />

            <Separator />

            {fetchingSegments ? (
              <NoDataFoundContainer>
                <CircularProgress />
              </NoDataFoundContainer>
            ) : (
              <Segments>
                {wheelSegments && wheelSegments.length > 0 ? (
                  wheelSegments?.map((segment) => {
                    const isSegmentIncluded = wheel.wheel_segments.some(
                      (s) => s.id === segment.id
                    );
                    return (
                      <SegmentItem key={segment.id}>
                        <SegmentName
                          color={segment.settings?.color}
                          bgColor={getPaletteColor(segment.settings?.color)}
                          borderColor={
                            selectedSegment?.id === segment.id
                              ? "#6B21A8"
                              : undefined
                          }
                          onClick={() => previewSegment(segment.id)}
                          isSelected={selectedSegment?.id === segment.id}
                        >
                          <SegmentColorIndicator
                            color={segment.settings?.color}
                          />
                          <TextView
                            variant="largeText"
                            style={{ fontWeight: 700 }}
                          >
                            {segment?.settings?.title || segment?.title}
                          </TextView>
                        </SegmentName>
                        <IconContainer
                          isSelected={selectedSegment?.id === segment.id}
                          onClick={() => addSegmentToWheel(segment.id)}
                        >
                          <img src={AddIcon} alt="add" width={24} height={24} />
                        </IconContainer>
                      </SegmentItem>
                    );
                  })
                ) : (
                  <NoDataFoundContainer>
                    <TextView variant="largeText" style={{ fontWeight: 700 }}>
                      No segments to show!
                    </TextView>
                  </NoDataFoundContainer>
                )}
              </Segments>
            )}
          </SegmentsContainer>
        )}
      </Container>
      {showSegmentPreview && createPortal(overlay, document.body)}
    </>
  );
}
